export default __webpack_public_path__ + "static/pattern-style-3-90d60fe48c3f208f7e42009cf6bbba08.png";